export default "<section class=\"limited-rtf\">\n  <h2>{{title}}</h2>\n  <div class=\"rtf\">\n    {{{content}}}\n  </div>\n</section>"